import React from "react";
import styled, { css } from "styled-components";
import { ButtonBase } from "@material-ui/core";

function PricingCard(props) {
  let plan = props.plan;

  return (
    <div onClick={props.onClick} key={props.key} className={props.className}>
      <span className="price">{plan.price}</span>
      <span className="title">{plan.name}</span>
      <span className="tokens">{plan.exams} Tokens</span>
      <span className="text">{plan.detail}</span>
      <ButtonBase onClick={props.onClick}>
        <div>Buy Now</div>
      </ButtonBase>
    </div>
  );
}

export default styled(PricingCard)`
  height: 550px;
  width: 350px;
  ${props =>
    !props.primary &&
    css`
      top: 55px;
      height: 450px;
      width: 300px;
    `}

  border-radius: 8px;
  background: ${props => (props.primary ? "#3b4f67" : "#fff")};
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  padding: 100px 0;
  position: relative;
  box-shadow: #3335 0 0 18px;
  overflow: hidden;
  @media (max-width: 900px) {
    && {
      width: 80%;
      height: auto;
      max-width: 350px;
      padding: 25px 0;
      cursor: pointer;
      top: 0;
      margin-bottom: 20px;
      button {
        display: none;
      }
      .tokens {
        margin: 20px 0;
      }
      .price {
        width: auto;
        right: 0px;
        border-radius: 0 0 0 8px;
        font-weight: 700;
        font-size: 1.2em;
      }
    }
  }
  button {
    border: ${props => (props.primary ? "none" : "1px solid #222")};
    border-radius: 8px;
    background-color: ${props => (props.primary ? "#fb9338" : "#fff")};
    color: ${props => (props.primary ? "white" : "#222")};
    text-transform: uppercase;
    font-size: 16px;
    cursor: pointer;
    padding: ${props => (props.primary ? "20px 50px" : "15px 40px")};
    outline: none;
  }
  .text {
    color: ${props => (props.primary ? "white" : "#b7b7b7")};
    font-family: sans-serif;
    width: 25ch;
    text-align: center;
  }

  .title {
    color: ${props => (props.primary ? "white" : "#000")};
    text-transform: uppercase;
    font-family: sans-serif;
    font-weight: bold;
    font-size: 1.1em;
  }
  .tokens {
    color: ${props => (props.primary ? "#FB9338" : "#3B4F68")};
    font-family: sans-serif;
    font-size: 2.8em;
    font-weight: 600;
  }

  .price {
    position: absolute;
    top: 0;
    right: 20px;
    background-color: ${props => (props.primary ? "#FB9338" : "#CACACA")};
    color: white;
    font-family: sans-serif;
    font-size: 1.5em;
    width: 80px;
    text-align: center;
    border-radius: 0 0px 8px 8px;
    padding: 10px;
    line-height: 0.9;
  }
`;
